<!-- src/app/pages/dashboard/statistics/uploaded-files-widget.component.html -->
<div class="card mb-0 widget-card">
  <div class="flex justify-between mb-4 items-center">
    <div>
      <span class="block text-muted-color font-medium mb-2">{{ translateServ.dictionary['STAT_HEAD_UPLOADS'] }}</span>

      <!-- Loading / values -->
      <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
        <ng-container *ngIf="loading">{{ translateServ.dictionary['LOADING'] }}</ng-container>
        <ng-container *ngIf="!loading">
          {{ totalFiles === null ? '—' : (totalFiles | number) }}
        </ng-container>
      </div>
    </div>

    <div
      class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border"
      style="width: 2.5rem; height: 2.5rem"
    >
      <i class="pi pi-cloud-upload text-blue-500 !text-xl"></i>
    </div>
  </div>

  <div>
    <span class="text-primary font-medium">
      {{ lastMonthFiles === null ? '...' : (lastMonthFiles | number) }}
    </span>
    <span class="text-muted-color"> {{ translateServ.dictionary['STAT_CURR_MO_MSG_UPL'] }}</span>
  </div>

  <div *ngIf="error" class="text-red-500 mt-2">{{ error }}</div>
</div>
